/**
 * MediaSource helper
 */

export function getMediaSource() {
  if (typeof window !== 'undefined') {
    return window.MediaSource || window.WebKitMediaSource;
  }
}



// WEBPACK FOOTER //
// ./src/helper/mediasource-helper.js